import {CodigoBarras} from "../model/produto/codigo-barras";

export class CodigoBarrasUtil {

    public static getInstance(): CodigoBarras {
        return new CodigoBarras();
    }

}
